(function () {
  'use strict';

  var MAX_VISIBLE_RESULTS = 80;
  var DEFAULT_CENTER = [39.8283, -98.5795];
  var DEFAULT_ZOOM = 4;

  // Authoritative store-data URL. Hardcoded here (rather than read only from the
  // section's data-stores-url attribute) so a stale "Stores JSON URL" value saved
  // in the theme editor can't make the locator load an older file that lacks the
  // per-store product codes ("p"). Update this when re-uploading the store JSON.
  var STORES_URL = 'https://cdn.shopify.com/s/files/1/0717/9606/4491/files/wlm-stores-6-17-26.json?v=1782137117';

  var PRODUCT_CATALOG = {
    '669-6Z':  { code: '669-6Z',  label: '5 lb Fluke Anchor',     url: 'https://www.walmart.com/ip/Greenfield-Slip-Ring-Fluke-Anchor-5-lb-Steel-PE-Coated-Model-669-6Z-WLM-Small/1411679312',  img: 'https://cdn.shopify.com/s/files/1/0717/9606/4491/files/669-6Z-WLM.jpg?v=1782136667' },
    '669-11Z': { code: '669-11Z', label: '6.5 lb Fluke Anchor',   url: 'https://www.walmart.com/ip/Greenfield-Slip-Ring-Fluke-Anchor-6-5-lb-Steel-PE-Coated-Model-669-11Z-WLM-Med/1130185847', img: 'https://cdn.shopify.com/s/files/1/0717/9606/4491/files/669-11Z-WLM.jpg?v=1782136668' },
    '410-B':   { code: '410-B',   label: '10 lb Mushroom Anchor',  url: 'https://www.walmart.com/ip/Greenfield-Products-Mushroom-Anchor-10-lb-Cast-Iron-Model-410-B-WLM/780225368',            img: 'https://cdn.shopify.com/s/files/1/0717/9606/4491/files/410-B-WLM.jpg?v=1782136668' },
    '415-B':   { code: '415-B',   label: '15 lb Mushroom Anchor',  url: 'https://www.walmart.com/ip/Greenfield-Products-Mushroom-Anchor-15-lb-Cast-Iron-Model-415-B-WLM/860003193',            img: 'https://cdn.shopify.com/s/files/1/0717/9606/4491/files/415-B-WLM.jpg?v=1782136668' },
    '516-B':   { code: '516-B',   label: '15 lb River Anchor',     url: 'https://www.walmart.com/ip/Greenfield-Products-River-Anchor-15-lb-Cast-Iron-Model-516-B-WLM/206660806',              img: 'https://cdn.shopify.com/s/files/1/0717/9606/4491/files/516-B-WLM.jpg?v=1782136668' },
    '518-B':   { code: '518-B',   label: '18 lb River Anchor',     url: 'https://www.walmart.com/ip/Greenfield-Products-River-Anchor-18-lb-Cast-Iron-Model-518-B-WLM/584216160',              img: 'https://cdn.shopify.com/s/files/1/0717/9606/4491/files/518-B-WLM.jpg?v=1782136668' }
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function milesBetween(lat1, lng1, lat2, lng2) {
    var earthMiles = 3958.8;
    var toRadians = function (degrees) { return degrees * Math.PI / 180; };
    var deltaLat = toRadians(lat2 - lat1);
    var deltaLng = toRadians(lng2 - lng1);
    var originLat = toRadians(lat1);
    var targetLat = toRadians(lat2);
    var a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2)
      + Math.cos(originLat) * Math.cos(targetLat)
      * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);

    return earthMiles * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function availability(store) {
    if (Number(store.q) > 0) {
      return {
        label: 'Available in store',
        markerClass: '',
        pillClass: '',
        detail: 'Greenfield products are listed for this Walmart location.'
      };
    }

    return {
      label: 'Check availability',
      markerClass: ' sl-marker--limited',
      pillClass: ' sl-pill--warning',
      detail: 'Inventory can change. Confirm availability before making a dedicated trip.'
    };
  }

  function parseCatalog(node) {
    var map = {};
    if (!node) {
      return map;
    }
    try {
      var list = JSON.parse(node.textContent || '[]');
      list.forEach(function (item) {
        if (item && item.code) {
          map[item.code] = item;
        }
      });
    } catch (error) {
      console.error('[store-locator] Could not parse product catalog:', error);
    }
    return map;
  }

  function productTiles(catalog, codes) {
    if (!Array.isArray(codes) || !codes.length) {
      return '';
    }

    var tiles = codes.map(function (code) {
      var product = catalog[code];
      if (!product) {
        return '';
      }
      var media = product.img
        ? '<img class="sl-product__img" src="' + escapeHtml(product.img) + '" alt="" loading="lazy">'
        : '<span class="sl-product__img sl-product__img--empty" aria-hidden="true"></span>';

      return ''
        + '<a class="sl-product" data-product href="' + escapeHtml(product.url) + '"'
        + ' target="_blank" rel="noopener noreferrer"'
        + ' aria-label="Shop ' + escapeHtml(product.label) + ' on Walmart.com">'
        + media
        + '<span class="sl-product__label">' + escapeHtml(product.label) + '</span>'
        + '<span class="sl-product__cta">Shop on Walmart.com</span>'
        + '</a>';
    }).join('');

    if (!tiles) {
      return '';
    }

    return ''
      + '<span class="sl-shop">'
      + '<span class="sl-shop__title">Also available on Walmart.com</span>'
      + '<span class="sl-shop__grid">' + tiles + '</span>'
      + '</span>';
  }

  function directionsUrl(store) {
    var address = [store.a, store.c, store.s + ' ' + store.z].filter(Boolean).join(', ');
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(address);
  }

  function storeAddress(store) {
    return escapeHtml(store.a) + '<br>' + escapeHtml(store.c) + ', ' + escapeHtml(store.s) + ' ' + escapeHtml(store.z);
  }

  function waitForLeaflet(callback) {
    if (window.L) {
      callback();
      return;
    }

    window.setTimeout(function () {
      waitForLeaflet(callback);
    }, 40);
  }

  function createIcon(store, isActive) {
    var info = availability(store);
    var className = isActive ? 'sl-marker sl-marker--active' : 'sl-marker' + info.markerClass;
    var markerUrl = store.__markerUrl || '';
    var markerHtml = markerUrl
      ? '<img src="' + escapeHtml(markerUrl) + '" alt="" loading="lazy">'
      : '';

    return window.L.divIcon({
      className: '',
      html: '<div class="' + className + '">' + markerHtml + '</div>',
      iconSize: isActive ? [54, 54] : [44, 44],
      iconAnchor: isActive ? [27, 27] : [22, 22],
      popupAnchor: [0, -18]
    });
  }

  function StoreLocator(root) {
    this.root = root;
    this.storesUrl = STORES_URL || root.getAttribute('data-stores-url') || '';
    this.markerUrl = root.getAttribute('data-marker-url') || '';
    this.defaultRadius = Number(root.getAttribute('data-default-radius')) || 25;
    this.stores = [];
    this.results = [];
    this.activeStoreId = null;
    this.markers = {};
    this.radiusCircle = null;
    this.originMarker = null;

    this.mapEl = root.querySelector('[data-sl-map]');
    this.messageEl = root.querySelector('[data-sl-map-message]');
    this.searchForm = root.querySelector('[data-sl-search]');
    this.zipInput = root.querySelector('[data-sl-zip]');
    this.radiusInput = root.querySelector('[data-sl-radius]');
    this.submitButton = root.querySelector('[data-sl-submit]');
    this.statusEl = root.querySelector('[data-sl-status]');
    this.totalEl = root.querySelector('[data-sl-total]');
    this.resultsEl = root.querySelector('[data-sl-results]');
    this.loadingEl = root.querySelector('[data-sl-loading]');
    this.map = null;
    this.catalog = PRODUCT_CATALOG;
  }

  StoreLocator.prototype.init = function () {
    var self = this;

    if (!this.mapEl || !this.searchForm || !this.resultsEl) {
      return;
    }

    if (this.radiusInput) {
      this.radiusInput.value = String(this.defaultRadius);
    }

    waitForLeaflet(function () {
      self.initMap();
      self.bindEvents();
      self.loadStores();
    });
  };

  StoreLocator.prototype.initMap = function () {
    this.map = window.L.map(this.mapEl, {
      zoomControl: true,
      scrollWheelZoom: true,
      dragging: true,
      tap: true,
      touchZoom: true
    }).setView(DEFAULT_CENTER, DEFAULT_ZOOM);

    window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 18
    }).addTo(this.map);
  };

  StoreLocator.prototype.bindEvents = function () {
    var self = this;

    this.searchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      self.search();
    });

  };

  StoreLocator.prototype.setLoading = function (isLoading) {
    if (this.loadingEl) {
      this.loadingEl.hidden = !isLoading;
    }

    if (this.submitButton) {
      this.submitButton.disabled = isLoading;
      this.submitButton.textContent = isLoading ? 'Searching…' : 'Search';
    }
  };

  StoreLocator.prototype.setMessage = function (title, body, isHidden) {
    if (!this.messageEl) {
      return;
    }

    this.messageEl.classList.toggle('is-hidden', Boolean(isHidden));
    this.messageEl.innerHTML = '<strong>' + escapeHtml(title) + '</strong><span>' + escapeHtml(body) + '</span>';
  };

  StoreLocator.prototype.loadStores = async function () {
    if (!this.storesUrl) {
      this.statusEl.textContent = 'Store data URL is not configured.';
      this.setMessage('Store data missing', 'Paste the stores.json file URL in this Shopify section’s settings.', false);
      return;
    }

    try {
      var response = await fetch(this.storesUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }

      var payload = await response.json();
      this.stores = Array.isArray(payload.stores) ? payload.stores.filter(this.isValidStore) : [];
      this.statusEl.textContent = 'Ready to search';
      this.totalEl.textContent = this.stores.length.toLocaleString() + ' locations';
    } catch (error) {
      console.error('[store-locator] Failed to load store data:', error);
      this.statusEl.textContent = 'Could not load store data.';
      this.setMessage('Store data failed', 'Check the stores.json URL and try again.', false);
    }
  };

  StoreLocator.prototype.isValidStore = function (store) {
    return store
      && Number.isFinite(Number(store.lat))
      && Number.isFinite(Number(store.lng))
      && store.a
      && store.c
      && store.s
      && store.z;
  };

  StoreLocator.prototype.geocodeZip = async function (zip) {
    var url = 'https://nominatim.openstreetmap.org/search?format=json&postalcode='
      + encodeURIComponent(zip)
      + '&country=US&limit=1';
    var response = await fetch(url, { headers: { Accept: 'application/json' } });

    if (!response.ok) {
      throw new Error('Geocode HTTP ' + response.status);
    }

    var locations = await response.json();
    if (!locations.length) {
      return null;
    }

    return {
      lat: Number(locations[0].lat),
      lng: Number(locations[0].lon)
    };
  };

  StoreLocator.prototype.search = async function () {
    var rawZip = this.zipInput.value.trim();
    var zip = rawZip.replace(/\D/g, '').slice(0, 5);
    var radius = Number(this.radiusInput.value) || this.defaultRadius;

    if (!/^\d{5}$/.test(zip)) {
      this.statusEl.textContent = 'Enter a valid 5-digit ZIP code.';
      this.zipInput.focus();
      return;
    }

    if (!this.stores.length) {
      this.statusEl.textContent = 'Store data is still loading.';
      return;
    }

    this.setLoading(true);

    try {
      var origin = await this.geocodeZip(zip);
      if (!origin) {
        this.statusEl.textContent = 'ZIP code not found.';
        this.setMessage('No ZIP match', 'Try another nearby ZIP code.', false);
        return;
      }

      this.results = this.stores
        .map(function (store) {
          var distance = milesBetween(origin.lat, origin.lng, Number(store.lat), Number(store.lng));
          return Object.assign({}, store, { distance: distance, __markerUrl: this.markerUrl });
        }, this)
        .filter(function (store) {
          return store.distance <= radius;
        })
        .sort(function (left, right) {
          return left.distance - right.distance;
        });

      // Preselect the closest store so its in-stock products are on screen without
      // a click. Set before both renders: renderResults uses it to add `is-active`
      // to that card, and renderMap builds its marker icon from the same value, so
      // the pin highlights too. fitMap still frames every result, and selectStore is
      // deliberately not called here - it would pan away from that overview and
      // scroll the results list.
      this.activeStoreId = this.results.length ? this.results[0].id : null;
      this.renderResults(radius);
      this.renderMap(origin, radius);
    } catch (error) {
      console.error('[store-locator] Search failed:', error);
      this.statusEl.textContent = 'Search failed. Check your connection and try again.';
      this.setMessage('Search failed', 'The ZIP lookup service did not respond.', false);
    } finally {
      this.setLoading(false);
    }
  };

  StoreLocator.prototype.visibleResults = function () {
    return this.results.slice(0, MAX_VISIBLE_RESULTS);
  };

  StoreLocator.prototype.renderResults = function (radius) {
    var self = this;
    var visible = this.visibleResults();

    if (!this.results.length) {
      this.statusEl.textContent = 'No stores within ' + radius + ' miles.';
      this.totalEl.textContent = '';
      this.resultsEl.innerHTML = '<div class="sl-empty"><div class="sl-empty__icon" aria-hidden="true">'
        + '<svg viewBox="0 0 24 24" fill="none"><path d="M12 21s7-5.2 7-11.2A7 7 0 1 0 5 9.8C5 15.8 12 21 12 21Z" stroke="currentColor" stroke-width="1.8"/>'
        + '<path d="M12 12.3a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Z" stroke="currentColor" stroke-width="1.8"/></svg>'
        + '</div><p>No participating Walmart locations were found inside this radius. Try 50 or 100 miles.</p></div>';
      return;
    }

    this.statusEl.textContent = this.results.length + ' store' + (this.results.length === 1 ? '' : 's') + ' within ' + radius + ' miles';
    this.totalEl.textContent = visible.length < this.results.length
      ? 'Showing closest ' + visible.length
      : '';

    this.resultsEl.innerHTML = visible.map(function (store) {
      return self.storeCard(store, store.id === self.activeStoreId);
    }).join('');

    Array.prototype.forEach.call(this.resultsEl.querySelectorAll('[data-store-id]'), function (button) {
      button.addEventListener('click', function () {
        self.selectStore(button.getAttribute('data-store-id'));
      });
    });

    Array.prototype.forEach.call(this.resultsEl.querySelectorAll('[data-directions], [data-product]'), function (link) {
      link.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    });
  };

  StoreLocator.prototype.storeCard = function (store, isActive) {
    var info = availability(store);
    var activeClass = isActive ? ' is-active' : '';
    var address = storeAddress(store);
    var distance = Number(store.distance).toFixed(1);
    var destination = directionsUrl(store);
    var storeType = store.b ? escapeHtml(store.b) : 'Walmart';

    return ''
      + '<button class="sl-card' + activeClass + '" type="button" data-store-id="' + escapeHtml(store.id) + '">'
      + '<span class="sl-card__top">'
      + '<span class="sl-card__name">' + escapeHtml(store.n || store.c) + '</span>'
      + '<span class="sl-card__distance">' + distance + ' mi</span>'
      + '</span>'
      + '<span class="sl-card__type">' + storeType + '</span>'
      + '<span class="sl-card__address">' + address + '</span>'
      + '<span class="sl-card__actions">'
      + '<span class="sl-pill' + info.pillClass + '">' + escapeHtml(info.label) + '</span>'
      + '<a class="sl-directions" data-directions href="' + escapeHtml(destination) + '" target="_blank" rel="noopener noreferrer">Directions</a>'
      + '</span>'
      + '<span class="sl-card__expanded">'
      + '<span class="sl-card__meta">' + escapeHtml(info.detail) + '</span>'
      + productTiles(this.catalog, store.p)
      + '</span>'
      + '</button>';
  };

  StoreLocator.prototype.renderMap = function (origin, radius) {
    var self = this;
    var visible = this.visibleResults();

    Object.keys(this.markers).forEach(function (id) {
      self.map.removeLayer(self.markers[id]);
    });
    this.markers = {};

    if (this.radiusCircle) {
      this.map.removeLayer(this.radiusCircle);
      this.radiusCircle = null;
    }

    if (this.originMarker) {
      this.map.removeLayer(this.originMarker);
      this.originMarker = null;
    }

    this.radiusCircle = window.L.circle([origin.lat, origin.lng], {
      radius: radius * 1609.344,
      color: '#323373',
      weight: 1.5,
      dashArray: '8 8',
      fillColor: '#323373',
      fillOpacity: 0.045
    }).addTo(this.map);

    this.originMarker = window.L.circleMarker([origin.lat, origin.lng], {
      radius: 7,
      color: '#ffffff',
      weight: 3,
      fillColor: '#323373',
      fillOpacity: 1
    }).addTo(this.map);

    visible.forEach(function (store) {
      var marker = window.L.marker([Number(store.lat), Number(store.lng)], {
        icon: createIcon(store, store.id === self.activeStoreId),
        keyboard: true,
        title: store.n || 'Walmart'
      }).addTo(self.map);

      marker.on('click', function () {
        self.selectStore(store.id);
      });

      self.markers[store.id] = marker;
    });

    this.fitMap();

    if (this.results.length) {
      this.setMessage('Showing nearby stores', 'The closest store is open below. Select another for its details.', true);
    } else {
      this.setMessage('No nearby stores', 'Try a larger radius or another ZIP code.', false);
    }
  };

  StoreLocator.prototype.fitMap = function () {
    var layers = Object.keys(this.markers).map(function (id) {
      return this.markers[id];
    }, this);

    if (this.originMarker) {
      layers.push(this.originMarker);
    }

    if (layers.length > 1) {
      this.map.fitBounds(window.L.featureGroup(layers).getBounds().pad(0.18));
      return;
    }

    if (this.radiusCircle) {
      this.map.fitBounds(this.radiusCircle.getBounds().pad(0.08));
    }
  };

  StoreLocator.prototype.selectStore = function (storeId) {
    var self = this;
    var selected = this.results.find(function (store) {
      return String(store.id) === String(storeId);
    });

    if (!selected) {
      return;
    }

    this.activeStoreId = selected.id;

    Object.keys(this.markers).forEach(function (id) {
      var store = self.results.find(function (item) { return String(item.id) === String(id); });
      if (store) {
        self.markers[id].setIcon(createIcon(store, String(store.id) === String(self.activeStoreId)));
      }
    });

    if (this.markers[selected.id]) {
      this.map.panTo([Number(selected.lat), Number(selected.lng)], { animate: true, duration: 0.35 });
    }

    this.renderResults(Number(this.radiusInput.value) || this.defaultRadius);

    var activeCard = this.resultsEl.querySelector('.sl-card.is-active');
    if (activeCard) {
      this.scrollResultIntoView(activeCard);
    }
  };

  StoreLocator.prototype.scrollResultIntoView = function (card) {
    var container = this.resultsEl;
    requestAnimationFrame(function () {
      if (container.scrollHeight > container.clientHeight) {
        var cardRect = card.getBoundingClientRect();
        var containerRect = container.getBoundingClientRect();
        var offset = cardRect.top - containerRect.top + container.scrollTop;
        container.scrollTop = Math.max(offset - 12, 0);
      } else {
        card.scrollIntoView({ block: 'center' });
      }
    });
  };

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sl-root]'), function (root) {
      if (root.__storeLocator) {
        return;
      }

      root.__storeLocator = new StoreLocator(root);
      root.__storeLocator.init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
